import { useEffect, useState } from "react";
import { apiFetch } from "../apiFetch";
import type { RefuelEvent } from "../types/strategy";

const POLL_MS = 30_000;

export function useRefuels(sessionId: number | null): RefuelEvent[] {
  const [refuels, setRefuels] = useState<RefuelEvent[]>([]);

  useEffect(() => {
    if (!sessionId) {
      setRefuels([]);
      return;
    }
    let cancelled = false;
    const fetchRefuels = async () => {
      try {
        const res = await apiFetch(`/api/sessions/${sessionId}/refuels`);
        if (!res.ok || cancelled) return;
        const data = (await res.json()) as { refuels?: RefuelEvent[] };
        if (!cancelled) setRefuels(Array.isArray(data.refuels) ? data.refuels : []);
      } catch (err) {
        console.warn("[refuels] fetch failed", err);
      }
    };
    fetchRefuels();
    const interval = window.setInterval(fetchRefuels, POLL_MS);
    return () => {
      cancelled = true;
      window.clearInterval(interval);
    };
  }, [sessionId]);

  return refuels;
}
